import { useCallback, useEffect, useRef, useState } from 'react';

import { statusService } from '@/services/instance/status';

function useRepeatCall(fn: () => Promise<void>, timeout: number) {
    const timeoutIdRef = useRef(0);

    const start = useCallback(async () => {
        await fn();

        timeoutIdRef.current = window.setTimeout(() => {
            void start();
        }, timeout);
    }, [fn, timeout]);

    const stop = useCallback(() => {
        clearTimeout(timeoutIdRef.current);
    }, []);

    useEffect(() => {
        return () => stop();
    }, [stop]);

    return [start, stop] as const;
}

export function useSystemStatusWatch() {
    const [hasUnresolvedIncidents, setStatus] = useState(false);

    const watchStatus = useCallback(async () => {
        const status = await statusService.hasUnresolvedIncidents();

        if (hasUnresolvedIncidents !== status) {
            setStatus(status);
        }
    }, [hasUnresolvedIncidents]);

    const [activate, deActivate] = useRepeatCall(watchStatus, 1000 * 60);

    return {
        hasUnresolvedIncidents,
        activate,
        deActivate,
    };
}
